// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import type { ToggleStatsToggleItem } from '@makemydeal/dr-feature-toggles-client';
import { toggleUseRegistry } from '@makemydeal/dr-feature-toggles-client';
import type { SalesCheckinRootState } from '@makemydeal/dr-sales-checkin-store';
import type { ReduxMiddleware, ReduxNext, ReduxStore } from '@makemydeal/dr-shared-store';
import { bootstrapActionTypes, toggleStatsActionCreators, toggleStatsActionTypes } from '@makemydeal/dr-shared-store';
import { SALES_CHECKIN_APP_PREFIX, isFeatureToggleStatsEnabled, setupFeatureToggleStats } from '@makemydeal/dr-shared-ui-utils';

export const toggleStatsMiddleware: ReduxMiddleware<SalesCheckinRootState> =
    (store: ReduxStore<SalesCheckinRootState>) => (next: ReduxNext) => async (action: AnyFSA) => {
        next(action);
        switch (action.type) {
            case bootstrapActionTypes.BOOTSTRAP_SUCCESS: {
                if (isFeatureToggleStatsEnabled(action.payload)) {
                    const updateToggleStatsApiCall = (toggleStatsItems: ToggleStatsToggleItem[]) => {
                        const updateToggleStatsAction = toggleStatsActionCreators.updateFeatureToggleStatsRequest(
                            SALES_CHECKIN_APP_PREFIX,
                            toggleStatsItems
                        );
                        store.dispatch(updateToggleStatsAction);
                    };
                    setupFeatureToggleStats(action.payload, updateToggleStatsApiCall);
                }
                break;
            }
            case toggleStatsActionTypes.UPDATE_FEATURE_TOGGLE_STATS_SUCCESS: {
                toggleUseRegistry.onApiCallSuccess();
                break;
            }
            case toggleStatsActionTypes.UPDATE_FEATURE_TOGGLE_STATS_FAILURE: {
                const message = action.payload.message;
                const response = action.payload.response;
                toggleUseRegistry.onApiCallFailure(message, response);
                break;
            }
        }
    };
